import { render, staticRenderFns } from "./IconMagnifyingGlass.vue?vue&type=template&id=16a31524&"
import script from "./IconMagnifyingGlass.vue?vue&type=script&lang=ts&"
export * from "./IconMagnifyingGlass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports